import { useQuery } from '@tanstack/react-query';
import iotApi from 'lib/api/iotApi.client';
import { PlanQueryKey } from './plan.hooks.keys';

export function useGetAllPlans() {
  return useQuery({
    queryKey: [PlanQueryKey.GET_ALL_PLANS],
    queryFn: async () => {
      const res = await iotApi.plan.getAllPlans();

      return res;
    },
  });
}
